export function getLiveRetailTaxType(vehicleType: string | number, countryCode: string) {
  const isLCV = Number(vehicleType) === 20;

  if (isLCV && countryCode.toUpperCase() === 'GB') {
    return 'vehicleRetailMarketStats.withoutVat';
  }

  return 'vehicleRetailMarketStats.gross';
}
